import { Cond, Product, ProductProject } from '@shop/models/src/product.js';
import lng from './lang.js';
import obj from './obj.js';
import { swap } from './array.js';

const guidelines = {
  't-shirts': {
    yarn: {
      image: '/assets/sizing-guideline/tshirt.webp',
      description:
        'تیشرت نخی ساده معمولاً برای روزهای گرم و آفتابی مناسب است و به دلیل سبک بودن، به راحتی می‌توان آن را بر روی لباس‌های دیگر پوشید. جنس تیشرت نخی ساده معمولاً از نخ‌های طبیعی یا مصنوعی ساخته می‌شود و به دلیل راحتی و سبک بودن، مورد پسند بسیاری از افراد است.',
      sizes: {
        M: {
          shoulders: '۱۷ سانتی متر',
          tallness: '۶۸ سانتی متر',
          chest: '۴۷ سانتی متر',
          sleeves: '۱۹ سانتی متر',
        },
        L: {
          shoulders: '۱۸ سانتی متر',
          tallness: '۷۰ سانتی متر',
          chest: '۵۰ سانتی متر',
          sleeves: '۲۰ سانتی متر',
        },
        XL: {
          shoulders: '۱۹ سانتی متر',
          tallness: '۷۲ سانتی متر',
          chest: '۵۲ سانتی متر',
          sleeves: '۲۱ سانتی متر',
        },
        '2XL': {
          shoulders: '۲۰ سانتی متر',
          tallness: '۷۴ سانتی متر',
          chest: '۵۴ سانتی متر',
          sleeves: '۲۲ سانتی متر',
        },
      },
    },
    'cotton-yarn': {
      image: '/assets/sizing-guideline/tshirt.webp',
      description:
        'تیشرت نخ پنبه از الیاف طبیعی ساخته شده و بسیار نرم، سبک و راحت است. این پارچه تنفس‌پذیر است و در روزهای گرم حس خنکی و راحتی ایجاد می‌کند. همچنین به دلیل سازگاری بالا با پوست، گزینه‌ای مناسب برای استفاده روزمره محسوب می‌شود.',
      sizes: {
        M: {
          shoulders: '۲۵ سانتی متر',
          tallness: '۷۱ سانتی متر',
          chest: '۶۱ سانتی متر',
          sleeves: '۲۷ سانتی متر',
        },
        L: {
          shoulders: '۲۶ سانتی متر',
          tallness: '۷۵ سانتی متر',
          chest: '۶۴ سانتی متر',
          sleeves: '۲۸ سانتی متر',
        },
      },
    },
    'crystal-cotton': {
      image: '/assets/sizing-guideline/tshirt.webp',
      description:
        'تیشرت اورسایز با پارچه کریستال سبک و خنک، انتخابی عالی برای روزهای گرم سال است. این پارچه با گردش هوای مناسب و لطافت روی پوست، راحتی بالایی در استفاده روزمره ایجاد می‌کند. قواره اورسایز در کنار ریزش خوب پارچه، استایلی آزاد و مدرن به لباس می‌دهد.',
      sizes: {
        M: {
          shoulders: '۲۵ سانتی متر',
          tallness: '۷۱ سانتی متر',
          chest: '۶۱ سانتی متر',
          sleeves: '۲۷ سانتی متر',
        },
        L: {
          shoulders: '۲۶ سانتی متر',
          tallness: '۷۵ سانتی متر',
          chest: '۶۴ سانتی متر',
          sleeves: '۲۸ سانتی متر',
        },
      },
    },
    macan: {
      image: '/assets/sizing-guideline/tshirt.webp',
      description:
        'تیشرت اورسایز با پارچه ماکان گرم بالا از پارچه‌ای ضخیم، باکیفیت و خوش‌فرم تولید شده که ایستایی بسیار خوبی روی بدن دارد. این پارچه علاوه بر نرمی و راحتی، دوام بالایی داشته و در برابر استفاده روزمره و شست‌وشو مقاوم است. قواره اورسایز آن نیز استایلی مدرن، آزاد و شیک ایجاد می‌کند.',
      sizes: {
        M: {
          shoulders: '۲۵ سانتی متر',
          tallness: '۷۱ سانتی متر',
          chest: '۶۱ سانتی متر',
          sleeves: '۲۷ سانتی متر',
        },
        L: {
          shoulders: '۲۶ سانتی متر',
          tallness: '۷۵ سانتی متر',
          chest: '۶۴ سانتی متر',
          sleeves: '۲۸ سانتی متر',
        },
      },
    },
  },
  hoodies: {
    'cotton-yarn': {
      image: '/assets/sizing-guideline/hoodie.webp',
      description:
        'هودی جنس نخ پنبه یک انتخاب عالی برای لباس زمستانی است. این نوع هودی از سه نوع نخ پنبه، پلی‌استر و نایلون ساخته شده است. از مزایای این جنس می توان به راحتی، گرمای زیاد، شستشوی آسان و قیمت مناسب آن اشاره کرد. هودی جنس سه نخ پنبه به دلیل مزایای فوق، مورد پسند بسیاری از افراد است و به عنوان یک انتخاب عالی برای لباس زمستانی به شمار می‌آید.',
      sizes: {
        L: {
          shoulders: '۲۴ سانتی متر',
          tallness: '۷۵ سانتی متر',
          chest: '۵۴ سانتی متر',
          sleeves: '۵۳ سانتی متر',
        },
        XL: {
          shoulders: '۲۶ سانتی متر',
          tallness: '۷۷ سانتی متر',
          chest: '۵۸ سانتی متر',
          sleeves: '۵۵ سانتی متر',
        },
        '2XL': {
          shoulders: '۲۸ سانتی متر',
          tallness: '۸۰ سانتی متر',
          chest: '۶۲ سانتی متر',
          sleeves: '۵۷ سانتی متر',
        },
      },
    },
  },
  dors: {
    'cotton-yarn': {
      image: '/assets/sizing-guideline/dors.webp',
      description:
        'هودی جنس نخ پنبه یک انتخاب عالی برای لباس زمستانی است. این نوع دورس از سه نوع نخ پنبه، پلی‌استر و نایلون ساخته شده است. از مزایای این جنس می توان به راحتی، گرمای زیاد، شستشوی آسان و قیمت مناسب آن اشاره کرد. دورس جنس سه نخ پنبه به دلیل مزایای فوق، مورد پسند بسیاری از افراد است و به عنوان یک انتخاب عالی برای لباس زمستانی به شمار می‌آید.',
      sizes: {
        L: {
          shoulders: '۱۳ سانتی متر',
          tallness: '۷۳ سانتی متر',
          chest: '۵۳ سانتی متر',
          sleeves: '۶۶ سانتی متر',
        },
        XL: {
          shoulders: '۱۴ سانتی متر',
          tallness: '۷۴ سانتی متر',
          chest: '۵۶ سانتی متر',
          sleeves: '۶۷ سانتی متر',
        },
        '2XL': {
          shoulders: '۱۵ سانتی متر',
          tallness: '۷۵ سانتی متر',
          chest: '۵۹ سانتی متر',
          sleeves: '۶۸ سانتی متر',
        },
      },
    },
  },
  mug: {
    ceramic: {
      image: '/assets/sizing-guideline/mug.webp',
      description:
        'ماگ سرامیکی ساده مناسب برای نوشیدن قهوه و چای و دیگر نوشیدنی ها است. به علت ساده بودن مناسب اکثر سلیقه ها است و ظاهری شیک و جذاب دارد.',
      sizes: {
        '330ml': {
          diameter: '۸.۵ سانتی متر',
          height: '۹.۵ سانتی متر',
        },
      },
    },
    heated: {
      image: '/assets/sizing-guideline/mug.webp',
      description:
        'ماگ حرارتی ممکن است با نام‌‌های دیگری همچون لیوان حرارتی و یا لیوان جادویی نیز خوانده شود، نحوه‌‌ی کار آن بدین صورت است که در ابتدا که داخل لیوان خالی است و در دمای معمولی اتاق قرار دارد، طرح روی ماگ، کاملا مشکی است اما وقتی که داخل آن نوشیدنی داغ می‌‌ریزید، کم کم طرح مشکی محو شده و طرح چاپ شده بر روی آن نمایان می‌‌گردد.',
      sizes: {
        '330ml': {
          diameter: '۸.۵ سانتی متر',
          height: '۹.۵ سانتی متر',
        },
      },
    },
  },
};

type Guidelines = (typeof guidelines)[keyof typeof guidelines];

export type PropTypes = keyof Product['props'];
export type State = { [K in PropTypes]?: string };

export function parseExprCond(cond: string): {
  propName: string;
  value: string;
} {
  const [propName, value] = cond.split('.', 2);
  if (propName == null || value == null)
    throw new Error('propName or value is null');
  return { propName, value };
}

export function matchCondition(state: State, cond: Cond): boolean {
  if (cond.length == 0) {
    return true;
  } /* empty expression */
  for (const andClause of cond) {
    if (
      andClause.every((x) => {
        const j = parseExprCond(x);
        return state[j.propName as PropTypes] === j.value;
      })
    ) {
      return true;
    }
  }
  return false;
}

type Result =
  | {
      isOk: true;
    }
  | {
      isOk: false;
      expr: string[];
      msg: string;
    };

export function findConflict(state: State, cond: Cond): string[] | null {
  for (const andClause of cond) {
    if (
      andClause.every((x) => {
        const j = parseExprCond(x);
        return state[j.propName as PropTypes] === j.value;
      })
    ) {
      return andClause;
    }
  }
  return null;
}

const msgMap = {
  color: 'این رنگ',
  material: (m: keyof typeof lng.material) =>
    lng.material[m] ? `${lng.material.prop} ${lng.material[m]}` : null,
  size: (s: keyof typeof lng.size) =>
    lng.size[s] ? `${lng.size.prop} ${lng.size[s]}` : null,
} as Record<string, string | ((m: string) => string)>;

export function formulateConflictMsg(conflict: string[]) {
  const msg: string[] = ['امکان انتخاب'];
  for (const cond of conflict) {
    const { propName, value } = parseExprCond(cond);
    const msgValue = msgMap[propName];
    const chunk = typeof msgValue === 'function' ? msgValue(value) : msgValue;
    if (!chunk) {
      console.error(`failed to find translation for key ${propName}`);
      return 'گزینه های انتخابی با هم تطابق ندارند';
    }
    msg.push(chunk, 'با');
  }
  msg.splice(-1, 1);
  msg.push('وجود ندارد');
  return msg.join(' ');
}

export class ProductState {
  __state: State = {};
  product: Product;
  project: Product['project'];
  price: number = 0;
  discount: number = 0;
  inventory: number = 0;
  variant: ProductProject['variants'][number];
  guidelines: Guidelines | null = null;
  status: Result | null = null;

  constructor(
    product: Product,
    project: Product['project'] = product.project,
    initialState?: State,
  ) {
    this.product = product;
    this.project = project;

    let currentVariantIndex = project.variants.findIndex(
      (v) => v.id === project.currentVariantId,
    );
    currentVariantIndex = currentVariantIndex > 0 ? currentVariantIndex : 0; // default to 0 to maintain backward compatibility
    this.variant = project.variants[currentVariantIndex]!;

    for (const key in guidelines) {
      if (project.tags?.includes(key)) {
        this.guidelines = guidelines[key as keyof typeof guidelines];
        break;
      }
    }

    if (initialState == null) {
      // move currentVariantIndex to first so it has priority over other variants
      const variants = swap(project.variants, currentVariantIndex, 0);

      for (const variant of variants) {
        const props = { ...variant.props };
        // if any state is null, fill it with the first option
        for (const propName of Object.keys(product.props)) {
          if (props[propName] == null && product.props[propName]?.length > 0) {
            props[propName] = product.props[propName][0];
          }
        }
        const { isOk } = this.setState(props);
        if (this.inventory !== 0 && isOk) {
          break;
        }
      }
    } else {
      this.setState(initialState);
    }
  }

  calculatePrice() {
    this.price = 0;
    this.discount = 0;
    for (const selector of this.product.priceSelector) {
      if (matchCondition(this.__state, selector.cond)) {
        if (selector.price < 0) {
          this.discount += Math.abs(selector.price);
        } else {
          this.price += selector.price;
        }
      }
    }
  }

  updateInventory() {
    this.inventory = 0;
    for (const selector of this.product.inventorySelector) {
      if (matchCondition(this.__state, selector.cond)) {
        this.inventory = selector.inventory;
        break;
      }
    }
  }

  state() {
    const product = this.product;
    return {
      props: this.__state,
      price: this.price,
      discount: {
        price: this.discount,
        percent: Math.ceil((this.discount / this.price) * 100),
      },
      variant: this.variant,
      guidelines: this.guidelines,
      status: this.status,
      inventory: this.inventory,
      inStock: {
        get product() {
          return product.inventorySelector.some((i) => i.inventory > 0);
        },
        variant: this.inventory > 0,
      },
    };
  }

  updateState(propName: PropTypes, value: string): Result {
    const newState = {
      ...this.__state,
      [propName]: value,
    };

    return this.setState(newState);
  }

  setState(newState: State): Result {
    const conflict = findConflict(newState, this.product.propConflictSelector);
    this.__state = newState;

    if (conflict != null) {
      return (this.status = {
        isOk: false,
        expr: conflict,
        msg: formulateConflictMsg(conflict),
      });
    }

    this.updateVariant();
    this.calculatePrice();
    this.updateInventory();

    return (this.status = {
      isOk: true,
    });
  }

  updateVariant() {
    for (const v of this.project.variants) {
      const _state = { ...this.__state };
      delete _state.designArea;
      if (obj.compare.shallow(_state, v.props)) {
        this.variant = v;
        break;
      }
    }
  }
}
